import { get } from 'lodash';
import { Service } from 'app/service/types';

export default function isServiceHidden(service: Service) {
  return service.isHidden || get(service, 'hidden');
}
